import { Grid, Typography } from '@mui/material';
import { SubmitButton } from '@tassat/button';
import { ClientMessagesTypeMap } from '@tassat/common-definitions';
import React from 'react';

import ClientMessageContentDetails from 'SharedComponents/clientMessages/clientMessageContentDetails';

import type { ApproveClientMessageProps } from '.';

export function ApproveClientMessage(props: ApproveClientMessageProps) {
    const {
        classes,
        selectedMessage,
        approveMessage,
        cancelConfirm,
        approvalError
    } = props;

    return (
        <Grid
            container
            direction='column'
            spacing={0}
        >
            <Typography
                className={classes.promptText}
                variant='body1'
            >Please confirm approving the below {ClientMessagesTypeMap[selectedMessage.ClientMsgType]} message for display to clients.
            </Typography>
            <ClientMessageContentDetails
                selectedMessage={selectedMessage}
            />
            <Grid
                alignItems='center'
                className={classes.buttonContainer}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <SubmitButton
                    onClick={approveMessage}
                    type='approve'
                />
                {approvalError &&
                    <span>{approvalError}</span>}
                <span
                    className={classes.cancelButton}
                    onClick={cancelConfirm}
                >CANCEL
                </span>
            </Grid>
        </Grid>
    );
}